import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";
import type {
    ApiStockOrder,
    ApiStockOrderContent,
    ApiStockOrderSupplyDoc,
    StockOrderContentFilter,
    StockOrderFilter,
} from "./types";

interface StockOrdersResponse {
    stockOrders: ApiStockOrder[];
}

interface StockOrderContentsResponse {
    stockOrderContents: ApiStockOrderContent[];
}

interface StockOrderSupplyDocsResponse {
    supplyDocs: ApiStockOrderSupplyDoc[];
}

/** Транспортный слой OMP — приходные ордера. */
export const stockOrdersApi = {
    /**
     * Загружает приходные ордера по фильтру.
     * @param params фильтр списка
     * @param config опции HTTP-запроса
     */
    load: async (
        params: {
            flt?: StockOrderFilter;
        },
        config?: RequestConfig,
    ): Promise<ApiStockOrder[]> => {
        const { flt } = params;
        const data = await ompApiClient.postOmega<StockOrdersResponse>("stock/stockOrders.loadByFilter", { flt }, config);

        return data.stockOrders;
    },

    /**
     * Загружает сопроводительные документы для приходных ордеров
     * (`stock/stockOrders/supplyDocs.loadSupplyDocs`).
     * @param params коды приходных ордеров (`stockOrders`)
     * @param config опции HTTP-запроса
     */
    loadSupplyDocs: async (
        params: {
            stockOrders: number[];
        },
        config?: RequestConfig,
    ): Promise<ApiStockOrderSupplyDoc[]> => {
        const data = await ompApiClient.postOmega<StockOrderSupplyDocsResponse>(
            "stock/stockOrders/supplyDocs.loadSupplyDocs",
            params,
            config,
        );

        return data.supplyDocs;
    },

    content: {
        /**
         * Загружает строки состава приходного ордера.
         * @param params фильтр состава
         * @param config опции HTTP-запроса
         */
        load: async (
            params: {
                flt?: StockOrderContentFilter;
            },
            config?: RequestConfig,
        ): Promise<ApiStockOrderContent[]> => {
            const data = await ompApiClient.postOmega<StockOrderContentsResponse>(
                "stock/stockOrders/contents.loadByFilter",
                params,
                config,
            );

            return data.stockOrderContents;
        },
    },
} as const;
